<template>  
  <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >
    <v-flex xs6 class="inline-block px-4">      
      <v-text-field hide-details  :label="$t('Admin.MesureUnite.Form.Libelle')" v-model="mut_libelle" />            
      <v-text-field hide-details  :label="$t('Admin.MesureUnite.Form.Symbol')" v-model="mut_symbol" />            
    </v-flex>       
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'AdminMesureUniteForm'
})
export default class AdminMesureUniteForm extends Vue {  

  get modified(){
    return this.$store.myGetters.modifiedAdmMesureUnite
  }
    
  get mut_libelle() {
    return this.modified.MUT_LIBELLE!
  }
  set mut_libelle(value:string) {
    this.$store.myActions.MESUREUNITE_UPDATE_MODIFIED_ADM({
      MUT_LIBELLE:value
    })
  }

  get mut_symbol() {
    return this.modified.MUT_SYMBOL!
  }
  set mut_symbol(value:string) {
    this.$store.myActions.MESUREUNITE_UPDATE_MODIFIED_ADM({
      MUT_SYMBOL:value
    })
  }

}
</script>